import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../Utils/axiosInstance";

const baseUrl = process.env.REACT_APP_BASE_URL;

export const getCardBinData = createAsyncThunk(
  "binDetails/getCardBinData",
  async ({ token, inputData }) => {
    const sanitizedInputData = inputData.replace(/\s/g, "").slice(0, 9);
    const response = await axiosInstance.post(
      `${baseUrl}/checkout/sessions/${token}/bank-identification-numbers/${sanitizedInputData}`
    );
    return response.data;
  }
);

const initialState = {
  cardBinData: {},
  cardBinLoading: false,
  cardBinErrorMessage: "",
};

export const binDetailSlice = createSlice({
  name: "binDetails",
  initialState,
  reducers: {
    resetCardBinData: (state) => {
      state.cardBinData = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCardBinData.pending, (state) => {
        state.cardBinLoading = true;
        state.cardBinErrorMessage = "";
      })
      .addCase(getCardBinData.fulfilled, (state, action) => {
        state.cardBinLoading = false;
        state.cardBinData = action.payload;
      })
      .addCase(getCardBinData.rejected, (state, action) => {
        state.cardBinLoading = false;
        state.cardBinData = {};
        state.cardBinErrorMessage = action.error.message || "Unknown error";
      });
  },
});

export const { resetCardBinData } = binDetailSlice.actions;
export default binDetailSlice.reducer;


